import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-textarea-form',
	templateUrl: './textarea-form.component.html',
	styleUrls: ['./textarea-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TextareaFormComponent {
	@Input() form: UntypedFormGroup;

	@Input() id: string;

	@Input() label: string;

	@Input() value = null;

	@Input() disabled = false;

	@Input() readonly = false;

	@Input() required = false;

	@Input() rows = 2;

	@Input() maxLength = 400;

	constructor() { }

	onChange(event: any) {
		this.form.controls[this.id].patchValue(event.target.value);
	}
}
